import { initMonitoring } from '@nucleus-commerce/admin-kit/monitoring';
import { configureApiClient } from '@nucleus-commerce/api-client/transport';

import { session } from '@/shared/session/session';

import { config } from './config';
import { queryClient } from './query-client';
import { router } from './router';
import { followTwoFactorRequirement } from './two-factor-redirect';

const PUBLIC_PATHS = ['/login'];

/** Wires transport, monitoring and (in mock mode) MSW before the first render. */
export async function boot(): Promise<void> {
  initMonitoring({
    dsn: config.monitoringDsn,
    environment: config.env,
    release: config.release,
    surface: 'platform',
  });

  configureApiClient({
    baseURL: config.apiBaseUrl,
    surface: 'platform',
    hooks: {
      onError: (error) => {
        void followTwoFactorRequirement(error, {
          queryClient,
          router,
          pathname: window.location.pathname,
        });
      },
      onUnauthorized: () => {
        session.clearSession(queryClient);
        const { pathname, search } = window.location;
        if (!PUBLIC_PATHS.some((p) => pathname.startsWith(p))) {
          void router.navigate({ to: '/login', search: { redirect: `${pathname}${search}` } });
        }
      },
    },
  });

  if (config.apiMode === 'mock') {
    const { startMockWorker } = await import('@/mocks/browser');
    await startMockWorker();
  }
}
